import {HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import Swal, {SweetAlertResult} from 'sweetalert2';

@Injectable()
export class SwalService {
    constructor(private translateService: TranslateService) {
    }

    public showSuccess({title = 'Success', text = null}: {
        title?: string;
        text?: string
    } = {}): Promise<SweetAlertResult> {
        return Swal.fire({
            position: 'center',
            icon: 'success',
            title: title,
            text: text,
            timer: 3500
        });
    }

    public showConfirm({title = 'Are you sure?', text = null}: { title?: string; text?: string } = {}): Promise<
        SweetAlertResult
    > {
        return Swal.fire({
            position: 'center',
            text: text,
            title: title,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel'
        });
    }



    public showError({
                         title = 'Something went wrong',
                         titleParams = null,
                         text = null,
                         textParams = null,
                         html = null,
                         htmlParams = null,
                         timer = null
                     }: {
        title?: string,
        titleParams?: any,
        text?: string,
        textParams?: any,
        html?: string,
        htmlParams?: any,
        timer?: number
    } = {}): Promise<
        SweetAlertResult
    > {
        return Swal.fire({
            position: 'center',
            icon: 'error',
            title: this.translateService.instant(title, titleParams),
            text: text ? this.translateService.instant(text, textParams) : null,
            html: html ? this.translateService.instant(html, htmlParams) : null,
            timer,
            heightAuto: false,
        });
    }

    public showException(err: any): Promise<SweetAlertResult> {
        if (err instanceof HttpErrorResponse && err.status === 417) {
            let errorMessage = `Something went wrong! (${err.message})`;
            const errorCode = err.error ? err.error.error : null;
            const errorParam = err.error ? err.error.error_param : null;

            if (errorCode && errorParam) {
                errorMessage = `Field '${errorParam}' is ${errorCode}`;
            }

            return Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Server error',
                text: errorMessage
            });
        }

        return Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Server error',
            text: `Something went wrong! (${err.statusText || err.message})`
        });
    }
}
